/**
 * TrialBenefits - Checkmark list of trial/membership benefits
 *
 * Shows reassurance messages like "No charge until day 8"
 */

import { Urls } from '@/constants/urls';

type BenefitItem = { text: string; href?: string };

interface TrialBenefitsProps {
  /** Whether to show trial-specific messaging */
  isTrial?: boolean;
  /** Custom benefits to display (overrides defaults) */
  benefits?: string[];
}

const DEFAULT_TRIAL_BENEFITS: BenefitItem[] = [
  { text: 'No charge for 7 days' },
  { text: 'Cancel anytime' },
];

const DEFAULT_MEMBERSHIP_BENEFITS: BenefitItem[] = [
  { text: '30-day money-back guarantee', href: Urls.terms_of_service },
  { text: 'Cancel anytime' },
];

export function TrialBenefits({ isTrial = true, benefits }: TrialBenefitsProps) {
  const displayBenefits: BenefitItem[] =
    benefits
      ? benefits.map((text) => ({ text }))
      : isTrial
        ? DEFAULT_TRIAL_BENEFITS
        : DEFAULT_MEMBERSHIP_BENEFITS;

  return (
    <div className="flex flex-col items-center gap-2">
      {displayBenefits.map((benefit, index) => (
        <div key={index} className="flex items-center gap-2">
          <img
            src="/images/icons/payment-page-v2/icon-checkmark.svg"
            alt=""
            className="h-4 w-4 flex-shrink-0"
          />
          {benefit.href ? (
            <a
              href={benefit.href}
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm text-catch-dark-blue-90 underline decoration-slate-300 underline-offset-2 hover:decoration-slate-500"
            >
              {benefit.text}
            </a>
          ) : (
            <span className="text-sm text-catch-dark-blue-90">{benefit.text}</span>
          )}
        </div>
      ))}
    </div>
  );
}

export default TrialBenefits;
